// Small wrapper around the qrcode package to produce a PNG data URL for embedding
// in printed HTML documents (invoices, work orders). Returns '' on failure so the
// caller can simply omit the QR block.
import QRCode from 'qrcode';

export async function qrDataUrl(text, size = 132) {
  if (!text) return '';
  try {
    return await QRCode.toDataURL(text, {
      width: size,
      margin: 1,
      color: { dark: '#0d542b', light: '#ffffff' },
      errorCorrectionLevel: 'M',
    });
  } catch {
    return '';
  }
}
